import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ProductComponent } from './product.component';
import { ProductResolverService } from './services/product-resolver.service';
import { CanDeactivateGuard } from 'src/app/services/guards/can-deactivate.guard';
// import { StatesResolverService } from './services/states-resolver.service';

const routes: Routes = [
  {
    path: '', redirectTo: '/dashboard', pathMatch: 'full'
  },
  {
    path: 'new',
    component: ProductComponent,
    resolve: {
      product: ProductResolverService,
      // states: StatesResolverService,
    },
    canDeactivate: [
      CanDeactivateGuard
    ]
  },
  {
    path: ':id',
    component: ProductComponent,
    resolve: {
      product: ProductResolverService,
      // states: StatesResolverService,
    },
    canDeactivate: [
      CanDeactivateGuard
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [
    ProductResolverService,
    // StatesResolverService
  ]
})
export class ProductRoutingModule { }
